var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"x-number",style:(_vm.style)},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.loading ? 'Loading...' : _vm.number))]),_c('span',{staticClass:"unit"},[_vm._v(_vm._s(_vm.unit))])])
}
var staticRenderFns = []

export { render, staticRenderFns }